import MediaOwner from '@/common/models/media-owner/MediaOwner';
import state from '@/store/state';
import Validatable from '@/validator/Validatable';

interface IOwnerInfoApi {
  [key: string]: number; // key is media owner id, value is number of units from that owner in this cluster
}

interface IOwnerInfo {
  id: number;
  mediaOwner: MediaOwner;
  unitCount: number;
}

interface IUnitCluster {
  count: number;
  expansionZoom: number;
  id: number;
  latitude: number;
  longitude: number;
  bounds: {
    minLat: number;
    minLon: number;
    maxLat: number;
    maxLon: number;
  };
  unitIds?: number[];
  ownerInfo?: IOwnerInfo;
}

export interface IUnitClusterApi {
  count: number;
  expansion_zoom: number;
  id: number;
  latitude: number;
  longitude: number;
  bounds: {
    min_lat: number;
    min_lon: number;
    max_lat: number;
    max_lon: number;
  };
  unit_ids?: number[];
  owner_info?: IOwnerInfoApi;
}

export default class UnitCluster extends Validatable {
  count: number;

  expansionZoom: number;

  latitude: number;

  longitude: number;

  bounds: {
    minLat: number;
    minLon: number;
    maxLat: number;
    maxLon: number;
  };

  unitIds?: number[];

  ownerInfo?: IOwnerInfoApi;

  constructor(data: IUnitClusterApi) {
    super();

    this.count = data.count;
    this.expansionZoom = data.expansion_zoom;
    this.id = data.id;
    this.latitude = data.latitude;
    this.longitude = data.longitude;
    this.bounds = {
      minLat: data.bounds.min_lat,
      minLon: data.bounds.min_lon,
      maxLat: data.bounds.max_lat,
      maxLon: data.bounds.max_lon,
    };
    this.unitIds = data.unit_ids;
    this.ownerInfo = data.owner_info;
  }

  static fromApi(data: IUnitClusterApi): UnitCluster {
    return new UnitCluster(data);
  }

  static fromObject(data: IUnitCluster): UnitCluster {
    return UnitCluster.fromObject(data);
  }

  get mediaOwnersInfo(): IOwnerInfo[] {
    const storedMediaOwners: MediaOwner[] = state?.orgApp?.ReferenceData?.mediaOwners;
    const mediaOwnersInfoList: IOwnerInfo[] = [];

    Object.keys(this.ownerInfo).forEach((key) => {
      const id = parseInt(key, 10);
      const value = this.ownerInfo[key];

      mediaOwnersInfoList.push({
        id,
        mediaOwner: storedMediaOwners.find((mo) => mo.id === id),
        unitCount: value,
      });
    });

    return mediaOwnersInfoList;
  }
}
